import { type ReactElement, type ReactNode } from 'react';
import { s } from '@/theme/tokens';
import { Box, Text } from '@/ui/primitives';

type TagsFilterFieldEmptyOptionProps = {
  action?: ReactNode;
  actionPlacement?: 'left' | 'right';
  label?: string;
  optionFontSizePx: number;
  onActionClick: () => void;
};

export const TagsFilterFieldEmptyOption = ({
  action,
  actionPlacement = 'right',
  label,
  optionFontSizePx,
  onActionClick,
}: TagsFilterFieldEmptyOptionProps): ReactElement => (
  <Box
    sx={{
      alignItems: 'center',
      display: 'flex',
      gap: s('md'),
      justifyContent: actionPlacement === 'left' ? 'flex-start' : 'space-between',
      minWidth: 0,
      width: '100%',
    }}
  >
    {label ? (
      <Text
        role="bodyMuted"
        color="textPrimary"
        component="span"
        sx={{
          fontSize: `${optionFontSizePx}px`,
          lineHeight: 1.4,
          fontWeight: (theme) => theme.typography.body.fontWeight,
          minWidth: 0,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {label}
      </Text>
    ) : null}
    {action ? (
      <Box
        component="span"
        sx={{
          display: 'inline-flex',
          flex: actionPlacement === 'left' ? '1 1 auto' : '0 0 auto',
          minWidth: 0,
          width: actionPlacement === 'left' ? '100%' : 'auto',
        }}
        onMouseDown={(event) => {
          event.stopPropagation();
        }}
        onClick={(event) => {
          event.stopPropagation();
          onActionClick();
        }}
      >
        {action}
      </Box>
    ) : null}
  </Box>
);
